module.exports = __webpack_public_path__ + "static/media/gnb.1a45cb32.svg";